import { postRequest, getRequest } from '../utils/axios';
import axios from 'axios';

import { toQueryString } from '../utils/urls.js'


export const discoverService = {
    performSearch,
    performAudienceSearch,
};

function performSearch(keywords, onSuccess, onError) {
  return getRequest(
    `/api/v1/discover/${toQueryString({'keyword': keywords.map(k => encodeURIComponent(k))})}`,
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

// finds subreddits (this is the v2 version of the API)
function performAudienceSearch(params, onSuccess, onError) {
  return getRequest(
    `/api/v1/discover-v2/${toQueryString(params)}`,
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

